const AnjuAllReleases2018Static = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/4th-floor-balcony-ft-meezow" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000445591854-2idp45-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>4th Floor Balcony</strong><br/>
                (feat. Meezow)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/anjuonline/where-my-dogs-at" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000439292301-ro4zhc-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Rick Ross - BMF</strong><br/>
                (ANJU Online! Flip)
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default AnjuAllReleases2018Static;